export interface IFinishOrderRequest {

    UFOID: string;
    CC_FirstName: string;
    CC_LastName: string;
    CC_Number: string;
    CC_ExpMonth: number;
    CC_ExpYear: number;
    CC_CVC: number;
    OrderFormVersion: string;

}

export class FinishOrderRequest implements IFinishOrderRequest {

    UFOID: string;
    CC_FirstName: string;
    CC_LastName: string;
    CC_Number: string;
    CC_ExpMonth: number;
    CC_ExpYear: number;
    CC_CVC: number;
    OrderFormVersion: string;

}